import React from "react";
import { useMediaQuery, breakpoints } from "@tvg/design-system";
import { TableColumns, TableData } from "../types";
import { Cell, Column } from "./styled-components";

const renderRows =
  (data: TableData[], hasEmptyCorner: boolean) =>
  (col: TableColumns, colIndex: number, columns: TableColumns[]) => {
    const isMobile = useMediaQuery(breakpoints.desktop.max.sm);
    return (
      <Column
        {...col}
        isScrollable={columns.length > 9}
        key={`col-${colIndex.toString()}`}
        data-qa-label={`table-col-${colIndex + 1}`}
        width={isMobile ? 75 : undefined}
      >
        {data.map((row, rowIndex: number) => (
          <Cell
            isEmptyCorner={hasEmptyCorner && colIndex === 0 && rowIndex === 0}
            isFixed={!!col.isFixed}
            key={`row-${rowIndex.toString()}`}
            data-qa-label={`table-row-${colIndex + 1}`}
          >
            {row[col.dataKey]}
          </Cell>
        ))}
      </Column>
    );
  };

export const renderContent = (
  columns: TableColumns[],
  data: TableData[],
  hasEmptyCorner: boolean
) => columns.map(renderRows(data, hasEmptyCorner));
